type Props = {
  title?: string;
  message: string;
};
export const InlineNotification = (props: Props) => {
  return (
    <div className="notification">
      <div className="title">{props.title}</div>
      <div className="message">{props.message}</div>
    </div>
  );
};
